import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForLeafCollectionSummary } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { LoftReportSchemaObject } from "../LoftReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import { SignalCellularNull } from "@material-ui/icons";

const screenCode = "LOFTREPORT";

export function LoftReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [loft, setLoft] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        date: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        date: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(LoftReportSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = ["filedTagNumber", "fieldCollectionPointName", "filedRegistrationNumber",
        "fieldNetAmount", "loftNetAmount"];
    const [contentRowNames, setContentRowNames] = useState([]);
    const initialColumnNames = ["Tag Number", "Route Name", "Customer Reg Number", "Net /Kg", "Net /Kg"]
    const [columnNames, setColumnNames] = useState([]);

    const initialCsvHeaders = [
        { label: "Tag Number", value: "filedTagNumber" },
        { label: "Route Name", value: "fieldCollectionPointName" },
        { label: "Customer Reg Number", value: "filedRegistrationNumber" },
        { label: "Field Net /Kg", value: "fieldNetAmount" },
        { label: "Loft Net /Kg", value: "loftNetAmount" },
    ]
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [fieldDeductions, setFieldDeductions] = useState([]);
    const [loftDedutions, setLoftDeductions] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [loft.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [loft.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLoft({
            ...loft,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        clearTableData();
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLoft({
            ...loft,
            factoryID: target.value,
            routeID: "0"
        });
        clearTableData();
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLoft({
            ...loft,
            routeID: target.value,
        });
        clearTableData();
    }

    function handledateChange(target) {
        validateInputs(target);

        setLoft({
            ...loft,
            date: target.value,
        });
        clearTableData();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, LoftReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLOFTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLoft({
            ...loft,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(loft.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(loft.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, loft);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(loft);

        const result = await services.getLeafCollectionSummaryReportData(loft);

        var loftResultData = result.loftData;
        var fieldResultData = result.fieldData;

        var convertedLoftData = removeLoftDataDuplicates(loftResultData);
        var convertedFieldData = removeFieldDataDuplicates(fieldResultData);

        var tableData = mergeFactoryAndLoftData(convertedLoftData.finalresult, convertedFieldData.finalResult);
        setDynamicHeaders(convertedLoftData.loftDeductions, convertedFieldData.fieldDeductions);

        if (tableData.length > 0) {
            setIsTableHide(false);
            setReportData(tableData);
            createDataTable();
        }
    }

    function setDynamicHeaders(loftDeductions, fieDeductions) {
        var copyOfContentRowNames = _.cloneDeep(initialContentRownames);
        var copyOfColumnNames = _.cloneDeep(initialColumnNames);
        var copyOfCsvHeaders = _.cloneDeep(initialCsvHeaders);

        var fieldDeductionsIds = [];
        var fieldDedutionNames = [];
        var loftDeductionsIds = [];
        var loftDedutionNames = [];
        var fieldsCsv = [];
        var loftCsv = [];

        fieDeductions.forEach(x => {
            fieldDeductionsIds.push(x.id);
            fieldDedutionNames.push(x.name);
            fieldsCsv.push(
                { label: ("Field" + x.name), value: x.id }
            )
        });

        loftDeductions.forEach(x => {
            loftDeductionsIds.push(x.id);
            loftDedutionNames.push(x.name);
            loftCsv.push(
                { label: ("Loft" + x.name), value: x.id }
            )
        });

        copyOfContentRowNames.splice(4, 0, ...fieldDeductionsIds);
        copyOfContentRowNames.splice(5 + loftDeductionsIds.length, 0, ...loftDeductionsIds);

        copyOfColumnNames.splice(4, 0, ...fieldDedutionNames);
        copyOfColumnNames.splice(5 + loftDedutionNames.length, 0, ...loftDedutionNames);

        copyOfCsvHeaders.splice(4, 0, ...fieldsCsv);
        copyOfCsvHeaders.splice(5 + loftCsv.length, 0, ...loftCsv);

        setColumnNames(copyOfColumnNames);
        setContentRowNames(copyOfContentRowNames);
        setCsvHeaders(copyOfCsvHeaders);
    }

    function mergeFactoryAndLoftData(loftData, FieldData) {
        var merged = _.merge(_.keyBy(loftData, 'loftProductCollectionDetailsID'), _.keyBy(FieldData, 'productCollectionDetailsID'));
        var values = _.values(merged);

        values.forEach(x => {
            for (const property in x) {
                if (property !== "fieldCollectionPointName" && property !== "filedTagNumber"
                    && property !== "filedRegistrationNumber") {
                    x[property] = parseFloat(x[property]).toFixed(2);
                }
            }
        });

        return values;
    }

    function removeLoftDataDuplicates(data) {
        var result = [];
        var deductionArray = [];
        var complexResult;

        data.forEach(x => {

            if (x.loftDeductionTempId !== null) {
                deductionArray.push({ id: x.loftDeductionTempId + "Lo", name: x.loftDeductionTypeName });
            }

            if (result.length === 0) {
                result.push(mapLoftData(x));
            } else {
                var selectedLoftItem = result.find(y => y.loftProductCollectionDetailsID === x.loftProductCollectionDetailsID);

                if (!selectedLoftItem) {
                    result.push(mapLoftData(x));
                } else {
                    if (x.loftDeductionTempId !== null) {
                        selectedLoftItem[x.loftDeductionTempId + "Lo"] =
                            (selectedLoftItem[x.loftDeductionTempId + "Lo"] === undefined ? 0 : parseFloat(selectedLoftItem[x.loftDeductionTempId + "Lo"]))
                               + (x.loftDeductionAmount === undefined ? 0 : parseFloat(x.loftDeductionAmount));
                    }
                }
            }
        });


        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)

        setLoftDeductions(uniqDeductions);

        complexResult = {
            finalresult: result,
            loftDeductions: uniqDeductions
        }

        return complexResult;
    }

    function mapLoftData(record) {
        var newRecord = {
            loftNetAmount: record.loftNetAmount,
            loftProductCollectionDetailsID: record.loftProductCollectionDetailsID,
            loftTagNumber: record.loftTagNumber,
            loftCollectionPointID: record.loftCollectionPointID
        }

        if (record.loftDeductionTempId !== null)
            newRecord[record.loftDeductionTempId + "Lo"] = (record.loftDeductionAmount);

        return newRecord;
    }

    function removeFieldDataDuplicates(data) {
        var result = [];
        var deductionArray = [];
        var complexResult;

        data.forEach(x => {

            if (x.filedDeductionTempId !== null) {
                deductionArray.push({ id: x.filedDeductionTempId + "Fi", name: x.fieldDeductionTypeName });
            }

            if (result.length === 0) {
                result.push(mapFieldData(x));
            } else {
                var selectedFieldItem = result.find(y => y.productCollectionDetailsID === x.productCollectionDetailsID);

                if (!selectedFieldItem) {
                    result.push((x));
                } else {
                    if (x.filedDeductionTempId !== null) {
                        selectedFieldItem[x.filedDeductionTempId + "Fi"] = (selectedFieldItem[x.filedDeductionTempId + "Fi"] === undefined ? 0 :
                            parseFloat(selectedFieldItem[x.filedDeductionTempId + "Fi"])) + (x.fieldDeductionAmount === undefined ? 0
                                : parseFloat(x.fieldDeductionAmount));
                    }
                }
            }
        });

        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)

        setFieldDeductions(uniqDeductions);

        complexResult = {
            finalResult: result,
            fieldDeductions: uniqDeductions
        }

        return complexResult;
    }

    function mapFieldData(record) {
        var newRecord = {
            fieldGrossAmount: record.fieldGrossAmount,
            fieldNetAmount: record.fieldNetAmount,
            productCollectionDetailsID: record.productCollectionDetailsID,
            filedTagNumber: record.filedTagNumber,
            filedRegistrationNumber: record.filedRegistrationNumber,
            fieldCollectionPointName: record.fieldCollectionPointName
        }

        if (record.filedDeductionTempId !== null)
            newRecord[record.filedDeductionTempId + "Fi"] = (record.fieldDeductionAmount);

        return newRecord;
    }

    function createDataTable() {
        $("#leafCollectionSummary").DataTable()
    }

    function createFile() {
        var settings = {
            sheetName: 'Loft Report',
            fileName: 'LoftReport',
            writeOptions: {}
        }

        xlsx(csvHeaders, reportData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLoft({
            ...loft,
            routeID: "0",
            date: ""
        });
        setErrors("");
        clearTableData();
    }

    function clearTableData() {
        setIsTableHide(true);
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            date: searchForm.date,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Loft Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={loft.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={loft.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={loft.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handledateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, loft)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="leafCollectionSummary" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th colSpan={3}></th>
                                                            <th colSpan={1 + fieldDeductions.length} style={{ textAlign: "center" }}>Field Weight /Kg</th>
                                                            <th colSpan={1 + loftDedutions.length} style={{ textAlign: "center" }}>Loft Weight /Kg</th>
                                                        </tr>
                                                        <tr>
                                                            {columnNames.map((x, index) => {
                                                                return (
                                                                    <th key={index}>{x}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForLeafCollectionSummary
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Loft Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} columnNames={columnNames} fieldDeductions={fieldDeductions}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} loftDedutions={loftDedutions} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
